import { RANKED_ORDER_TYPE } from './ranked';

export const CROSSTAB_INCLUDED_QUESTION_TYPES = [
    'multiple_choice',
    'matrix',
    'grid',
    'collapsed',
    'intensity_scale',
    RANKED_ORDER_TYPE,
];

export const CROSSTAB_EXCLUDED_SUBQUESTION_TYPES: string[] = [];

export const RESPONSE_EXCLUDED_QUESTION_TYPES = ['text', 'short_answer'];

export const STUDIO_SCHEMA_CXP = 'STUDIO_CXP';
export const STUDIO_SCHEMA_SYNDICATED = 'STUDIO_SYNDICATED';

export const ADMIN_ORG_SF_ID = '001d000002BBDTKAA5';

/**
 * Who a crosstab counts (X20, M4S-5777): the one home of the rule, bound by every crosstab, Reel
 * Studio and My Work query (`who-counts.guard.test.ts` fails on a literal).
 *
 * `survey_portal.survey_respondent.responded_id`, the portal's own codes (profiled for Feasibility
 * in `src/lib/feasibility/refresh/derivations.ts`):
 *   0 not responded · 1 complete · 2 terminate · 3 retired · 4 complete but hidden
 * A crosstab counts 1 only. 3 holds completes removed afterwards (the quality screen, a store
 * visit that did not verify) together with expired invitations and removed screen-outs; the portal
 * has no `responded_type` column to tell them apart. 4 is not counted here, though Feasibility
 * counts it as kept (`RESPONDED_ID IN (1, 4)`) for its own rates; whether the delivered data file
 * includes it is an open question (docs/pdlc/crosstabs-respondents.md). Payment rejections are not
 * visible in the portal at all. Changing this value moves every base: declare it.
 *
 * One complete is one diary entry; `respondent-unit.ts` turns entries into people.
 */
export const COMPLETE_RESPONDED_ID = 1;

/**
 * A respondent screened out (a terminate), the portal's code 2. Counted only by a crosstab someone
 * deliberately put on the screened-out data set (X22, `respondent-set.ts`), never mixed with
 * completes. The portal keeps a terminate's answers up to the point they were screened out.
 */
export const TERMINATE_RESPONDED_ID = 2;

export const CROSSTAB_CACHE_TTL = 300; // 5 minutes

export const CROSSTAB_CACHE_PREFIX = 'crosstab:data';
